import { AxiosResponse } from 'axios';
import { APICallInstance } from './APICallInstance';
import {
    GetAllOccupationsResponse,
    GetCellsResponse,
    GetCombinedConfigsResponse,
    GetEcoSectorsResponse,
    GetNicCodesResponse,
    GetOccupationGroupsResponse,
    GetOccupationsResponse,
    GetOccupationSubGroupsResponse,
    GetProvsAndDistrictsResponse,
    GetSectorsResponse,
    GetVillagesResponse
} from 'Application/models';

const configUrl = '/api/v1/config';

//* ConfigsService class for Rwanda KYC form inputs
class ConfigsServiceClass {
    getNicCodes = async () => {
        const url = `${configUrl}/nic-codes`;
        const response: AxiosResponse<GetNicCodesResponse> = await APICallInstance.get(url);
        return response.data;
    };

    getEconomicSectors = async () => {
        const url = `${configUrl}/economic/sector`;
        const response: AxiosResponse<GetEcoSectorsResponse> = await APICallInstance.get(url);
        return response.data;
    };

    getCombinedConfigs = async () => {
        const url = `${configUrl}/combined`;
        const response: AxiosResponse<GetCombinedConfigsResponse> = await APICallInstance.get(url);
        return response.data;
    };

    getProvincesAndDistricts = async () => {
        const url = `${configUrl}/province/district`;
        const response: AxiosResponse<GetProvsAndDistrictsResponse> = await APICallInstance.get(url);
        return response.data;
    };

    getSectors = async (districtCode: string) => {
        const url = `${configUrl}/district/sector`;
        const response: AxiosResponse<GetSectorsResponse> = await APICallInstance.get(url, {
            params: {
                districtCode
            }
        });
        return response.data;
    };

    getCells = async (sectorCode: string) => {
        const url = `${configUrl}/sector/cell`;
        const response: AxiosResponse<GetCellsResponse> = await APICallInstance.get(url, {
            params: {
                sectorCode
            }
        });
        return response.data;
    };

    getVillages = async (cellCode: string) => {
        const url = `${configUrl}/cell/village`;
        const response: AxiosResponse<GetVillagesResponse> = await APICallInstance.get(url, {
            params: {
                cellCode
            }
        });
        return response.data;
    };

    getOccuptaionGroups = async () => {
        const url = `${configUrl}/occupation-groups`;
        const response: AxiosResponse<GetOccupationGroupsResponse> = await APICallInstance.get(url);
        return response.data;
    };

    getAllOccuptaions = async () => {
        const url = `${configUrl}/occupation`;
        const response: AxiosResponse<GetAllOccupationsResponse> = await APICallInstance.get(url);
        return response.data;
    };

    getOccupationSubGroups = async (occupationGroupCode: string) => {
        const url = `${configUrl}/occupation-sub-groups`;
        const response: AxiosResponse<GetOccupationSubGroupsResponse> = await APICallInstance.get(url, {
            params: {
                occupationGroupCode
            }
        });
        return response.data;
    };

    getOccupations = async (occupationSubGroupCode: string) => {
        const url = `${configUrl}/occupation/option`;
        const response: AxiosResponse<GetOccupationsResponse> = await APICallInstance.get(url, {
            params: {
                occupationSubGroupCode
            }
        });
        return response.data;
    };

    getCancellationTypes = async () => {
        const url = `${configUrl}/cancellation-types`;
        const response: AxiosResponse<string[]> = await APICallInstance.get(url);
        return response.data;
    };
}

export const ConfigsService = new ConfigsServiceClass();
